import { Button } from '@wartek-id/button-v1'
import { Dialog, DialogOverlay, DialogContent } from '@wartek-id/dialog-v1'
import type { DialogProps } from '@wartek-id/dialog-v1'
import { Text } from '@wartek-id/text-v1'

type DialogPelaksanaanAppealConfirmationProps = Omit<
  DialogProps,
  'children'
> & {
  onCancel?: () => void
  onConfirm?: () => void
}

export function DialogPelaksanaanAppealConfirmation({
  onCancel,
  onConfirm,
  ...dialogProps
}: DialogPelaksanaanAppealConfirmationProps) {
  return (
    <Dialog size="sm" {...dialogProps}>
      <DialogOverlay />
      <DialogContent>
        <div className="p-6 space-y-4">
          <Text variant="display-sm">
            Seluruh dokumen akan dihapus. Jika lanjut, pastikan yang diubah:
          </Text>
          <div className="flex flex-col bg-blue-5 gap-2 p-3 rounded-md border border-interactive-hovered">
            <Text variant="action">Target Perilaku dan Upaya Mempelajari </Text>
            <Text color="subdued">
              Anda akan mengulang Observasi Praktik Kinerja dari awal. Pastikan
              Anda sudah diskusi dengan atasan.
            </Text>
          </div>
          <Text color="subdued">
            Jika ingin ubah jadwal atau mata pelajaran, lakukan dengan atasan{' '}
            <strong>di luar sistem.</strong>
          </Text>
          <div className="flex pt-2 space-x-5">
            <Button onClick={onCancel} color="white" size="lg">
              Kembali
            </Button>
            <Button onClick={onConfirm} color="blue" size="lg">
              Ubah Target Perilaku
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}
